import React, { useState } from 'react';

const PLANS = [
  { key: 'lean',        label: 'Lean'        },
  { key: 'performance', label: 'Performance' },
  { key: 'comfort',     label: 'Comfort'     },
];

const MEALS = ['breakfast', 'snack_1', 'lunch', 'snack_2', 'dinner'];
const MEAL_LABELS = {
  breakfast: 'Breakfast',
  snack_1:   'Morning Snack',
  lunch:     'Lunch',
  snack_2:   'Afternoon Snack',
  dinner:    'Dinner',
};

export default function Module05({ data }) {
  const { plans = {}, date } = data;
  const [active, setActive] = useState('lean');
  const plan = plans[active];

  return (
    <div className="space-y-5">

      {/* Plan selector */}
      <div className="flex gap-2">
        {PLANS.map(({ key, label }) => (
          <button
            key={key}
            onClick={() => setActive(key)}
            className="flex-1 py-2.5 text-[9px] tracking-[0.25em] uppercase font-medium transition-all border"
            style={active === key
              ? { borderColor: 'var(--gold)', color: 'var(--gold)' }
              : { borderColor: 'rgba(255,255,255,0.1)', color: '#555' }}
          >
            {label}
          </button>
        ))}
      </div>

      {plan && (
        <>
          {/* Macro totals */}
          <div className="grid grid-cols-4 gap-2">
            {[
              { label: 'Kcal',    value: plan.totals?.calories },
              { label: 'Protein', value: plan.totals?.protein ? plan.totals.protein + 'g' : '—' },
              { label: 'Carbs',   value: plan.totals?.carbs   ? plan.totals.carbs   + 'g' : '—' },
              { label: 'Fat',     value: plan.totals?.fat     ? plan.totals.fat     + 'g' : '—' },
            ].map(({ label, value }) => (
              <div key={label} className="border border-white/8 p-3 text-center">
                <p className="text-base font-light">{value ?? '—'}</p>
                <p className="text-[9px] tracking-[0.2em] uppercase text-gray-600 mt-1">{label}</p>
              </div>
            ))}
          </div>

          {/* Meals */}
          <div>
            {MEALS.map((meal) => {
              const m = plan.meals?.[meal];
              if (!m) return null;
              return (
                <div key={meal} className="py-4 border-b border-white/8 flex items-start justify-between gap-3">
                  <div className="flex-1">
                    <p className="text-[9px] tracking-[0.2em] uppercase text-gray-600 mb-1">{MEAL_LABELS[meal]}</p>
                    <p className="text-sm font-medium tracking-wide">{m.name}</p>
                    {m.ingredients && (
                      <p className="text-[10px] text-gray-500 mt-1 leading-relaxed">{m.ingredients}</p>
                    )}
                  </div>
                  <div className="text-right shrink-0">
                    <p className="text-sm font-light">{m.calories} <span className="text-[9px] text-gray-600">kcal</span></p>
                    <p className="text-[10px] text-gray-600 mt-0.5">{m.protein}g protein</p>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
